import {SalesInsight} from "../../domain/sales-insight.entity";
import {V2SalesInsightsData} from "./sales-insight.mapper.types";

/**
 * V2 mapper for SalesInsight.
 * Trivial since domain shape mirrors v2 - mainly applies defaults.
 *
 * Pure TypeScript - no React imports.
 */
export const SalesInsightMapperV2 = {
  /**
   * Maps v2 API response data to SalesInsight domain entity.
   */
  toDomain(data: V2SalesInsightsData): SalesInsight {
    return SalesInsight.create({
      totalAttendees: data.totalAttendees ?? 0,
      revenueByCurrency: data.totalRevenueByCurrency ?? {},
    });
  },
};
